export class AuthenticationEntity {
  accessToken;
  refreshToken;

  constructor(accessToken = "", refreshToken = "") {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
  }
}
